/**
 * レスポンシブデザイン関連の定数
 * ブレークポイント、PDF表示サイズなどの設定を一元管理
 */

export const RESPONSIVE = {
  /**
   * 画面サイズのブレークポイント（ピクセル）
   * 大画面でもコンパクトなレイアウトを維持するため、ブレークポイントを高めに設定
   */
  BREAKPOINTS: {
    DESKTOP_LARGE: 4000, // 超大型ディスプレイのみDESKTOP_LARGEレイアウト
    DESKTOP_MEDIUM: 3000, // ほぼすべてのPC画面でタブレットレイアウトを使用
    TABLET: 768,
  },

  /**
   * PDF表示サイズ設定
   * 各ブレークポイントでのPDF表示サイズとスケール範囲
   */
  PDF_SIZING: {
    DESKTOP_LARGE: {
      WIDTH_RATIO: 0.65,
      HEIGHT_RATIO: 0.85,
      SCALE_MIN: 1.5,
      SCALE_MAX: 3.5,
    },
    DESKTOP_MEDIUM: {
      WIDTH_RATIO: 0.6,
      HEIGHT_RATIO: 0.8,
      SCALE_MIN: 1.5,
      SCALE_MAX: 3.5,
    },
    TABLET: {
      WIDTH_RATIO: 0.5,
      HEIGHT_RATIO: 0.5,
      SCALE_MIN: 0.8,
      SCALE_MAX: 2.0,
    },
    MOBILE: {
      WIDTH_RATIO: 0.9,
      HEIGHT_RATIO: 0.45,
      SCALE_MIN: 0.8,
      SCALE_MAX: 2.0,
    },
  },

  /**
   * PDFコンテナのマージン（ピクセル）
   */
  PDF_CONTAINER_MARGIN: 40,
} as const;
